import React, { Component } from "react";
import QRCode from "qrcode.react";
import ReactDOM from "react-dom";
import "./index.css";
import BsySwitchBtn from "../BsySwitchBtn";
import AlertListSelectApp from "./selectApp";
import { BsyUtils } from "../../utils/Utils";
import BsyDateTime from "../BsyDateTime";
import BsyIconBtn from "../BsyIconBtn";
import { createTooltip } from "../../utils/createTooltip";
import tipAlert from "../../Login/BsyAlertTip/Staticize";

class AlertListMiniAppset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wxmini_join: props.wxmini_join,
      group_id: props.group_id,
      is_expire: 1, //1临时  0永久
      expire_time: 0,
      path: {
        appid: "",
        formid: "",
        name: "",
        icon: "",
        color: "",
      },
      link: "",
      status: 0,
      forever: true,
    };
    this.ShowImageId = "ShowQr-" + new Date().getTime();

    //有效期时间 大于当前时间
    this.expire_time_min = 1800000; //5 * 60 * 1000

    this.expire_time_max = 2592000000; //30 * 24 * 60 * 60 * 1000

    //是否要执行 生成按钮
    this.reset = false;
  }

  componentDidMount = () => {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  cancelClick = () => {
    this.props.onRemoveRoot();
    // document.getElementsByClassName("BsyAlertListDetail")[0].remove()
  };

  componentDidMount() {
    this.getMiniAppQrInfo();
  }

  getMiniAppQrInfo = () => {
    React.axios("/corp/outsider/share/info", {
      group_id: this.state.group_id,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          const newState = {
            ...this.state,
            ...res.data.data,
          };

          if (newState.is_expire && newState.expire_time === 0) {
            //临时模式，expire_time = 0 需要设置为 当前 + 30天
            newState.expire_time =
              (new Date().getTime() + this.expire_time_max) / 1000;
          }
          //请求后才改变二维码，所以手动处理状态
          this.expire_time = newState.expire_time;
          this.is_expire = newState.is_expire;
          this.link = newState.link;
          this.setState(newState);
          // this.showQr();
        });
      })
      .catch((res) => {});
  };

  //更新小程序二维码相关信息
  updateMiniAppQrInfo = () => {
    if (this.state.is_expire) {
      //临时模式必须传到期时间
      if (!this.state.expire_time) {
        tipAlert({
          type: "warning",
          msg:
            React.language("dash.data.manage.selectPlaceholder") +
            React.language("outsider.miniapp.seting.share.EffectiveTimeire"),
        });
        return;
      }
      if (
        new Date().getTime() + this.expire_time_min >
        this.state.expire_time * 1000
      ) {
        tipAlert({
          type: "warning",
          msg: React.language("outsider.miniapp.seting.share.limitTime.tip1"),
        });
        return;
      }

      if (
        new Date().getTime() + this.expire_time_max <
        this.state.expire_time * 1000
      ) {
        tipAlert({
          type: "warning",
          msg: React.language("outsider.miniapp.seting.share.limitTime.tip2"),
        });
        return;
      }

      // if((new Date()).getTime() + 60 * 1000 > this.data.expire_time / 1000 ) {
      //     tipAlert({
      //         type: "warning",
      //         msg: "二维码有效时间，必须大于当前时间"
      //     });
      // }
    }
    React.axios("/corp/outsider/share/update", {
      group_id: this.state.group_id,
      // status: this.state.status,
      is_expire: this.state.is_expire,
      expire_time: this.state.expire_time,
      path: { ...this.state.path },
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          //请求后才改变二维码，所以手动处理状态
          this.expire_time = this.state.expire_time;
          this.is_expire = this.state.is_expire;
          this.link = res.data.data.link;
          this.setState({
            link: res.data.data.link,
          });
        });
      })
      .catch((res) => {});
  };

  //更新 小程序的分享开关
  updateMiniAppInfo = (wxmini_join) => {
    React.axios("/corp/outsider/update", {
      group_id: this.state.group_id,
      wxmini_join: wxmini_join,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          this.setState({ wxmini_join: wxmini_join });
          if (this.props.onUpdata) {
            this.props.onUpdata({
              wxmini_join: wxmini_join,
            });
          }
        });
      })
      .catch((res) => {});
  };
  //开关
  switchChange = (data) => {
    this.updateMiniAppInfo(data);
  };

  switchMiniAppQrChange = (data) => {
    React.axios("/corp/outsider/share/update", {
      group_id: this.state.group_id,
      status: data,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          const newState = {
            ...this.state,
            ...res.data.data,
          };
          this.setState(newState);
        });
      })
      .catch((res) => {});
  };

  getAppValue = (value) => {
    this.setState({
      path: { ...this.state.path, ...value },
    });
  };

  changeIsExpire = (is_expire) => {
    this.setState({
      is_expire: is_expire,
    });
  };

  regenerateQR = () => {
    this.updateMiniAppQrInfo();
  };

  dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  downQrImage = (size, cm) => {
    const { link } = this;
    if (link) {
      const qrid = "qrCode_" + new Date().getTime();
      let qrlayer = document.createElement("div");
      qrlayer.style.position = "absolute";
      qrlayer.style.visibility = "hidden";
      document.body.appendChild(qrlayer);
      ReactDOM.render(
        <QRCode
          id={qrid}
          value={link} //value参数为生成二维码的链接
          size={size} //二维码的宽高尺寸
        />,
        qrlayer
      );
      const canvas = document.getElementById(qrid);
      var _dataURL = canvas.toDataURL("image/png");

      var blob_ = this.dataURLtoBlob(_dataURL); // 用到Blob是因为图片文件过大时，在一部风浏览器上会下载失败，而Blob就不会

      var url = {
        name: `${qrid}_${size}_${cm}cm.png`, // 使用模板字符串优化可读性，保留.png后缀保持文件类型明确
        src: blob_,
      };

      if (window.navigator.msSaveOrOpenBlob) {
        // if browser is IE
        navigator.msSaveBlob(url.src, url.name); //filename文件名包括扩展名，下载路径为浏览器默认路径
      } else {
        let links = document.createElement("a");
        links.setAttribute("href", window.URL.createObjectURL(url.src));
        links.setAttribute("download", url.name);
        document.body.appendChild(links);
        links.click();
        setTimeout(() => {
          document.body.removeChild(links);
        }, 100);
      }

      document.body.removeChild(qrlayer);
      ReactDOM.unmountComponentAtNode(qrlayer);
    }
  };

  renderExpireTime = () => {
    const { expire_time, is_expire, link } = this;

    if (!link) {
      return "";
    }

    const showTime = BsyUtils.getDateInfoFromNowString(expire_time * 1000);
    let date = new Date();
    if (is_expire && date.getTime() > expire_time * 1000) {
      return (
        <div className="block">
          <div className="block-body ">
            <span className="row-title warning">
              <i className="icon-tip-warning" />
              {React.language("outsider.miniapp.seting.share.Invalidation")}
            </span>
          </div>
        </div>
      );
    }
    let str = React.language("Left") + showTime;
    if (!is_expire) {
      str = React.language("outsider.miniapp.seting.share.permanentTime");
    }
    return (
      <div className="block">
        <div className="block-body">
          <span className="row-title">
            {React.language("outsider.miniapp.seting.share.EffectiveTimeire")}
          </span>
          <div
            className="show-time"
            dangerouslySetInnerHTML={{ __html: str }}
          ></div>

          <div className="block-body  " style={{ marginTop: 20 }}></div>
        </div>
      </div>
    );
  };

  render() {
    const { wxmini_join, status, path, is_expire, forever, link } = this.state;
    const { group_type, width } = this.props;

    return (
      <div className={"content " + window.mode} style={{ width: width }}>
        <div className="alertHeader">
          <div className="headerDetail">
            {React.language("outsider.miniapp.seting")}
          </div>
          <div className="alertClose">
            <i onClick={this.cancelClick} className="icon-close-large" />
          </div>
        </div>
        <div
          className="editContent"
          style={{
            height: "calc(100% - 80px)",
          }}
        >
          <div className="block">
            <div className="block-body prefix">
              <span className="row-title">
                {React.language("outsider.miniapp.seting.share.autojoin")}
              </span>
              <span className="tip">
                <i
                  data-tip={
                    parseInt(group_type) === 1
                      ? React.language(
                          "outsider.miniapp.seting.share.autojoin.tip1"
                        )
                      : React.language(
                          "outsider.miniapp.seting.share.autojoin.tip2"
                        )
                  }
                  onMouseEnter={(e) => {
                    this.showTooltip(
                      e.currentTarget,
                      parseInt(group_type) === 1
                        ? React.language(
                            "outsider.miniapp.seting.share.autojoin.tip1"
                          )
                        : React.language(
                            "outsider.miniapp.seting.share.autojoin.tip2"
                          ),
                      "bottom",
                      10
                    );
                  }}
                  onMouseLeave={() => {
                    this.hideTooltip();
                  }}
                  className="icon-shixinhelp"
                  data-place={"top"}
                  data-type={window.mode}
                  data-html={true}
                  data-class="mytip"
                ></i>
              </span>
              <BsySwitchBtn
                switchChange={this.switchChange}
                power={wxmini_join}
              />
            </div>
          </div>

          <div>
            <div className="block">
              <div className="block-body prefix">
                <span className="row-title">
                  {React.language("outsider.miniapp.seting.share.qr")}
                </span>
                <span className="tip">
                  <i
                    data-tip={React.language(
                      "outsider.miniapp.seting.share.qr.tip"
                    )}
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("outsider.miniapp.seting.share.qr.tip"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                    className="icon-shixinhelp"
                    data-place={"top"}
                    data-type={window.mode}
                    data-html={true}
                    data-class="mytip"
                  ></i>
                </span>
                <BsySwitchBtn
                  switchChange={this.switchMiniAppQrChange}
                  power={status}
                />
              </div>
            </div>
            {status ? (
              <div>
                <div className="block">
                  <div className="block-body">
                    <span className="row-title">
                      {React.language("outsider.miniapp.seting.share.home")}
                    </span>
                  </div>
                  <div className="block-body" style={{ marginTop: 20 }}>
                    <AlertListSelectApp
                      {...path}
                      onStopEdit={this.getAppValue}
                    />
                  </div>
                </div>
                <div className="block">
                  <div className="block-body">
                    <span className="row-title">
                      {React.language(
                        "outsider.miniapp.seting.share.expiretime"
                      )}
                    </span>
                  </div>
                  <div
                    className="block-body"
                    style={{ marginTop: 20, display: "flex" }}
                  >
                    <div
                      onClick={(e) => {
                        this.changeIsExpire(true);
                      }}
                      className={"x-radio " + (is_expire ? "select" : "")}
                    >
                      <i className="icon-blank"> </i>{" "}
                      <span>{React.language("temporary")}</span>
                    </div>
                    <BsyDateTime
                      {...{
                        customCls: is_expire ? "" : "x-ui-disable",
                        width: 200,
                        format: "yyyy-MM-dd HH:mm:ss",
                        value: this.state.expire_time * 1000,
                        start: "+30m",
                        end: "+30d",
                        onStopEdit: (val) => {
                          let expire_time =
                            new Date().getTime() + this.expire_time_max;
                          if (val) {
                            expire_time = parseInt(val / 1000);
                          } else {
                            expire_time = parseInt(val / 1000);
                          }
                          this.setState({
                            expire_time: expire_time,
                          });
                        },
                      }}
                    ></BsyDateTime>
                  </div>
                  {forever ? (
                    <div className="block-body" style={{ marginTop: 20 }}>
                      <div
                        onClick={(e) => {
                          this.changeIsExpire(false);
                        }}
                        className={"x-radio " + (is_expire ? "" : "select")}
                      >
                        <i className="icon-blank"> </i>{" "}
                        <span>{React.language("permanent")}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="block">
                  <div className="block-body reset-qr ">
                    <BsyIconBtn
                      text={
                        link
                          ? React.language(
                              "outsider.miniapp.seting.share.regenerate"
                            )
                          : React.language("generate")
                      }
                      type="blue"
                      click={(e) => {
                        this.regenerateQR();
                      }}
                      mode={window.mode}
                    />
                  </div>
                </div>

                <div className="block">
                  <div className="show-qr" id={this.ShowImageId}>
                    {link ? (
                      <QRCode
                        value={link} //value参数为生成二维码的链接
                        size={102} //二维码的宽高尺寸
                        // fgColor={fgColor}  //二维码的颜色
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="block-body">
                    <span className="row-title">
                      {React.language("outsider.miniapp.seting.share.qrsize")}
                    </span>
                    <span className="row-tip">
                      {"(" +
                        React.language(
                          "outsider.miniapp.seting.share.qrsize.tip"
                        ) +
                        ")"}
                    </span>
                  </div>

                  <div
                    className="block-body"
                    style={{ marginTop: 12 }}
                    onClick={(e) => {
                      this.downQrImage(258, 8);
                    }}
                  >
                    <div className={"row-qr-down"}>
                      <span>
                        {React.language(
                          "outsider.miniapp.seting.share.qrsize.8"
                        )}
                      </span>
                      <i className="icon-qrcode" title={""} />
                    </div>
                  </div>

                  <div
                    className="block-body"
                    style={{ marginTop: 12 }}
                    onClick={(e) => {
                      this.downQrImage(344, 12);
                    }}
                  >
                    <div className={"row-qr-down"}>
                      <span>
                        {React.language(
                          "outsider.miniapp.seting.share.qrsize.12"
                        )}
                      </span>
                      <i className="icon-qrcode" title={""} />
                    </div>
                  </div>

                  <div
                    className="block-body"
                    style={{ marginTop: 12 }}
                    onClick={(e) => {
                      this.downQrImage(430, 15);
                    }}
                  >
                    <div className={"row-qr-down"}>
                      <span>
                        {React.language(
                          "outsider.miniapp.seting.share.qrsize.15"
                        )}
                      </span>
                      <i className="icon-qrcode" title={""} />
                    </div>
                  </div>

                  <div
                    className="block-body"
                    style={{ marginTop: 12 }}
                    onClick={(e) => {
                      this.downQrImage(860, 30);
                    }}
                  >
                    <div className={"row-qr-down"}>
                      <span>
                        {React.language(
                          "outsider.miniapp.seting.share.qrsize.30"
                        )}
                      </span>
                      <i className="icon-qrcode" title={""} />
                    </div>
                  </div>

                  <div
                    className="block-body"
                    style={{ marginTop: 12 }}
                    onClick={(e) => {
                      this.downQrImage(1280, 50);
                    }}
                  >
                    <div className={"row-qr-down"}>
                      <span>
                        {React.language(
                          "outsider.miniapp.seting.share.qrsize.50"
                        )}
                      </span>
                      <i className="icon-qrcode" title={""} />
                    </div>
                  </div>
                </div>

                {this.renderExpireTime()}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default AlertListMiniAppset;
